import {twJoin} from "tailwind-merge";

/* Direct port of growthjockey--website/app/components/atoms/ctaButtonEmpty.tsx */
export function CtaButtonEmpty({
    className,
    text,
    arrow,
    href,
    onClick,
    type = "button",
    target,
}: {
    className?: string;
    text?: string;
    arrow: boolean;
    href?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    type?: "button" | "submit" | "reset";
    target?: "_blank";
}) {
    const contentClass = twJoin(
        "relative w-full grid grid-rows-1 grid-flow-col items-center px-2 py-1 lg:px-3 lg:py-2 gap-2 lg:gap-3 group no-underline",
        className,
    );

    const content = (
        <>
            <div className="absolute place-items-center bg-[#FFFFFF] inset-0 rounded-sm lg:rounded-lg border border-[#1A1D2E] opacity-100 transition-opacity duration-200 lg:group-hover:opacity-0" />
            <div className="absolute inset-0 rounded-sm lg:rounded-lg cta-border-gradient opacity-0 transition-opacity duration-200 lg:group-hover:opacity-100" />

            <div className="relative z-10 grid grid-flow-col grid-rows-1 items-center gap-1 lg:gap-sm">
                <div className="relative text-[#1A1D2E] grid items-center justify-center h-5">
                    <span className="text-nav-text-b transition-opacity duration-200 lg:group-hover:opacity-0">{text}</span>
                    <span className="absolute inset-0 grid items-center justify-center text-nav-text-b text-transparent bg-clip-text bg-[linear-gradient(90deg,#00A2ED_-20.83%,#1F40CB_106.03%)] transition-opacity duration-200 opacity-0 lg:group-hover:opacity-100">
                        {text}
                    </span>
                </div>

                {arrow === true && (
                    <div className="w-4 h-4 grid items-center justify-center mb-[1px]">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                        >
                            <defs>
                                <linearGradient
                                    id="arrowGradient"
                                    x1="2.13"
                                    y1="8.28"
                                    x2="13.48"
                                    y2="8.28"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#00A2ED" />
                                    <stop
                                        offset="1"
                                        stopColor="#1F40CB"
                                    />
                                </linearGradient>
                            </defs>
                            <path
                                d="M8.02867 12.3182L8.97133 13.2609L13.4427 8.78957L8.97133 4.31824L8.02867 5.2609L10.8907 8.1229H4.5V9.45624H10.8907L8.02867 12.3182Z"
                                className="fill-[#1A1D2E] transition-colors duration-200 group-hover:fill-[url(#arrowGradient)]"
                            />
                        </svg>
                    </div>
                )}
            </div>
        </>
    );

    if (href != null) {
        return (
            <a
                href={href}
                className={contentClass}
                target={target}
            >
                {content}
            </a>
        );
    }

    return (
        <button
            type={type}
            onClick={onClick}
            className={contentClass}
            aria-label={text}
        >
            {content}
        </button>
    );
}
